const API_PREFIX = "/settings";


export const getAllInfoService = () => `${API_PREFIX}`;
export const updateStartOnlineReservation = () => `${API_PREFIX}/online-reservation-start`;
export const updateEndOnlineReservation = () => `${API_PREFIX}/online-reservation-end`;
export const autoMarkAsDoneEndpoint = () => `${API_PREFIX}/auto-mark-as-done`;
export const pauseBetweenAppointmentsEndpoint = () => `${API_PREFIX}/pause-between-appointments`;
export const pauseBetweenAppointmentsCmsEndpoint = () => `${API_PREFIX}/pause-between-appointments-cms`;
export const locationTravelTimeEndpoint = () => `${API_PREFIX}/location-travel-time`;
export const viberStaffNotificationsEndpoint = () => `${API_PREFIX}/viber-staff-notifications`;
export const viberEnabledEndpoint = () => `${API_PREFIX}/viber-enabled`;
export const showAppointmentPriceEndpoint = () => `${API_PREFIX}/show-appointment-price`;
export const showAppointmentDurationEndpoint = () => `${API_PREFIX}/show-appointment-duration`;
export const onlineReservationDaysEndpoint = () => `${API_PREFIX}/online-reservation-days`;
export const onlineReservationTimePermanentEndpoint = () => `${API_PREFIX}/online-reservation-time-permanent`;
export const subscriptionPackageEndpoint = () => `${API_PREFIX}/subscription-package`;
export const clientCancellationWindowHoursEndpoint = () => `${API_PREFIX}/client-cancellation-window-hours`;